//--------------------------------------------------------------
// INDEX
//
// Entry point file for webpack.
//--------------------------------------------------------------

// SCSS
import '../scss/app.scss';

// Lazysizes
import 'lazysizes/lazysizes'; // @see https://github.com/aFarkas/lazysizes
import 'lazysizes/plugins/parent-fit/ls.parent-fit'; // @see https://github.com/aFarkas/lazysizes#parent-fit-extension
import 'lazysizes/plugins/bgset/ls.bgset'; // @see https://github.com/aFarkas/lazysizes#bgset-plugin---lazy-responsive-background-image
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'; // @see https://github.com/aFarkas/lazysizes/tree/gh-pages/plugins/unveilhooks
import 'lazysizes/plugins/respimg/ls.respimg'; // IE 11. Only uncomment and use for support in IE.


// // jQuery Extend
// import './extend';

// // Modals
// import './modal';

// // Custom
// import './custom';

// // Details Polyfil
// import './details-polyfil';

// // Tab Accordion
// import './tab-accordion';

// // Custom Tabs Page
// import './page-custom-tabs';

// // Navigation
// import './navigation';
// import './skip-nav';


// Codyhouse base js
// import 'codyhouse-framework/main/assets/js/util';
import { createApp } from 'vue';
import './codyhouse-components/index';
import NotificationsTriggerText from './vue-components/notifications/NotificationsTriggerText.vue';
import NotificationsTriggerMobile from './vue-components/notifications/NotificationsTriggerMobile.vue';
import NotificationsTriggerIconOnly from './vue-components/notifications/NotificationsTriggerIconOnly.vue';
import NotificationsBar from './vue-components/notifications/NotificationsBar.vue';
import NotificationsCount from './vue-components/notifications/NotificationsCount.vue';

const clickOutsideDirective = {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        if (typeof binding.value === 'function') {
          binding.value(event);
        } else if (binding.instance && binding.expression && typeof binding.instance[binding.expression] === 'function') {
          binding.instance[binding.expression](event);
        }
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
};

const notificationsComponentMap = {
  'notifications-trigger-text': NotificationsTriggerText,
  'notifications-trigger-mobile': NotificationsTriggerMobile,
  'notifications-trigger-icon-only': NotificationsTriggerIconOnly,
  'notifications-bar': NotificationsBar,
  'notifications-count': NotificationsCount,
};

function elementAttributesToProps(element) {
  const props = {};
  for (const attr of element.attributes) {
    props[attr.name] = attr.value;
  }
  return props;
}
// Init Vue components
let vueComponents = document.getElementsByClassName('vue-notifications-component');
if( vueComponents.length ) {
    for(let i = 0; i < vueComponents.length; i++ ) {
        const element = vueComponents[i];
        const tagName = element.tagName.toLowerCase();
        const component = notificationsComponentMap[tagName];
        if (!component) {
          continue;
        }

        const props = elementAttributesToProps(element);
        const app = createApp(component, props);
        app.directive('click-outside', clickOutsideDirective);
        app.mount(element);
    }
}

let image_caption_divs = document.getElementsByClassName('js-image-caption');
for(let i = 0; i< image_caption_divs.length; i++) {
  let caption_text = image_caption_divs[i].getAttribute('data-image-caption');
  if(caption_text.length) {
    let caption = document.createElement('span');
    caption.setAttribute('aria-hidden', 'true');
    caption.classList.add('image-caption','shadow-sm', 'position-absolute','padding-y-xs','padding-x-md', 'text-sm');
    caption.textContent = caption_text;
    image_caption_divs[i].append(caption);
  }
  
}
